<template>
  <a-carousel autoplay style="width: 100%;">
    <div v-for="(item,index) in productList" style="width: 100%;" :key="index">
      <div style="width: 100%;overflow: hidden;">
        <img :src="item.pictures" style="width: 100%;"/>
      </div>
      <div class="product_inf_content">
        <p-text :content="item.content" />
      </div>
    </div>
  </a-carousel>
</template>

<script>

  import PText from '@views/general/customcomponent/components/PText.vue'

  export default {
    name: 'PCarousel',
    props: {
      productList: {
        type: Array,
        default: () => []
      }
    },
    components: { PText },
    data() {
      return {}
    },
    methods: {}
  }
</script>


<style lang="less" scoped>
.widthStyle {
  width: 14rem;
  word-wrap: break-word;
}

.ant-carousel .slick-slide {
  text-align: center;
  height: 160px;
  line-height: 160px;
  background: #364d79;
  overflow: hidden;
}

.ant-carousel .custom-slick-arrow {
  width: 25px;
  height: 25px;
  font-size: 25px;
  color: #fff;
  background-color: rgba(31, 45, 61, 0.11);
  opacity: 0.3;
}

.ant-carousel .custom-slick-arrow:before {
  display: none;
}

.ant-carousel .custom-slick-arrow:hover {
  opacity: 0.5;
}

.ant-carousel .slick-slide h3 {
  color: #fff;
}

.product_inf_content {
  padding-bottom: 1.2rem;
}

.yellowfont {
  color: #faefac;
}

.width100 {
  width: 100%;
  padding: 0.2rem 0;
}

.inlineblock {
  display: inline-block;
}

.minfont {
  font-size: 1rem !important;
}
</style>
